import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export class M_STORE {
    hQ_CD: string = '';
    stR_CD: string = '';
    stR_NM: string = '';
    ceO_NM: string = '';

    biZ_NO: string = '';
    biZ_TYPE_CD: string = '';
    biZ_KIND_CD: string = '';
    biZ_GUBUN_CD: string = '';
    biZ_STR_NM: string = '';

    teL_NO: string = '';
    hP_NO: string = '';
    faX_NO: string = '';
    posT_NO: string = '';

    emaiL_ADDR: string = '';
    homepage: string = '';
    addr: string = '';
    addR_DTL: string = '';

    stR_STAT: string = '';
    stR_OPEN_DT: any | null = null;
    stR_CLOSE_DT: any | null = null;

    vaN_CD: string = '';
    vaN_CD_NM: string = "";
    tid: string = '';
    storE_AUTH_CD: string = '';

    comport: string = '';
    bauD_RATE: string = '';
    bauD_RATE_NM: string = '';
    agetnT_TP: string = '';

    reservE_YN: string = '';
    reserveChecked: boolean = false;
    reservE_AMT: number = 0;
    reservE_START_TIME: string = '';
    reservE_END_TIME: string = '';
    reservE_TIME_FG: string = '';

    membeR_FG: string = '';
    savE_CHARGE_FG: string = '';
    miN_POINT: number = 0;
    poinsT_PERIOD: number = 0;

    remark: string = '';
    usE_YN: string = '';

    carD_DEV_TP: string = '';
    carD_DEV_TP_NM: string = '';

    constructor(init?: Partial<M_STORE>) {
        Object.assign(this, init);
    }

    toJSON(): any {
        const obj: any = {};

        Object.keys(this).forEach(key => {
            const value = (this as any)[key];

            if (
                (key === 'stR_OPEN_DT' || key === 'stR_CLOSE_DT') &&
                value
            ) {
                obj[key] = this.formatDate(value);
            }
            else if ((key === 'teL_NO' || key === 'hP_NO') && value) {
                let digits = value.replace(/\D/g, '');

                if (digits.length <= 10) {
                    obj[key] = digits.substring(0, 10);
                } else {
                    obj[key] = digits.substring(0, 11);
                }
            }
            else if (key === 'biZ_NO' && value) {
                obj[key] = value.replaceAll('-', '');
            }
            else if (
                (key === 'reservE_START_TIME' || key === 'reservE_END_TIME') && value
            ) {
                const date = new Date(value);

                const hh = String(date.getHours()).padStart(2, '0');
                const mm = String(date.getMinutes()).padStart(2, '0');

                obj[key] = `${hh}${mm}`;
            }
            // else if (key === 'reservE_YN') {
            //     obj[key] = obj['reserveChecked'] === true ? 'Y' : 'N';
            // }
            else {
                obj[key] = value ?? null;
            }
        });

        return obj;
    }

    fromJSON(json: any): M_STORE {
        return new M_STORE(json);
    }

    getAllStores(res: any[]): M_STORE[] {
        return (res ?? []).map(res => {
            if (res.stR_OPEN_DT) {
                res.stR_OPEN_DT = this.parseYYYYMMDD(res.stR_OPEN_DT);
            }

            if (res.stR_CLOSE_DT) {
                res.stR_CLOSE_DT = this.parseYYYYMMDD(res.stR_CLOSE_DT);
            }

            if (res.teL_NO) {
                res.teL_NO = this.formatPhone(res.teL_NO);
            }

            if (res.hP_NO) {
                res.hP_NO = this.formatPhone(res.hP_NO);
            }

            if (res.biZ_NO) {
                res.biZ_NO = this.formatBizNo(res.biZ_NO);
            }

            if (res.reservE_START_TIME) {
                res.reservE_START_TIME = this.formatTime(res.reservE_START_TIME)
            }

            if (res.reservE_END_TIME) {
                res.reservE_END_TIME = this.formatTime(res.reservE_END_TIME)
            }

            return new M_STORE(res);
        });
    }

    getStore(res: any): M_STORE {
        if (!res) return new M_STORE();

        if (res.stR_OPEN_DT) {
            res.stR_OPEN_DT = this.parseYYYYMMDD(res.stR_OPEN_DT);
        }

        if (res.stR_CLOSE_DT) {
            res.stR_CLOSE_DT = this.parseYYYYMMDD(res.stR_CLOSE_DT);
        }

        if (res.teL_NO) {
            res.teL_NO = this.formatPhone(res.teL_NO);
        }

        if (res.hP_NO) {
            res.hP_NO = this.formatPhone(res.hP_NO);
        }

        if (res.biZ_NO) {
            res.biZ_NO = this.formatBizNo(res.biZ_NO);
        }

        if (res.reservE_START_TIME) {
            res.reservE_START_TIME = this.formatTime(res.reservE_START_TIME)
        }
        else {
            res.reservE_START_TIME = this.formatTime('0900')
        }

        if (res.reservE_END_TIME) {
            res.reservE_END_TIME = this.formatTime(res.reservE_END_TIME)
        }
        else {
            res.reservE_END_TIME = this.formatTime('2300');
        }

        if (!res.reservE_TIME_FG) {
            res.reservE_TIME_FG = '1';
        }
        return new M_STORE(res);
    }

    createForm(fb: FormBuilder): FormGroup {
        return fb.group(
            {
                hQ_CD: [this.hQ_CD],
                stR_CD: [{ value: this.stR_CD, disabled: true }],
                stR_NM: [{ value: this.stR_NM, disabled: true }],
                ceO_NM: [this.ceO_NM, [Validators.required]],

                biZ_NO: [{ value: this.biZ_NO, disabled: true }],
                biZ_TYPE_CD: [{ value: this.biZ_TYPE_CD, disabled: true }],
                biZ_KIND_CD: [this.biZ_KIND_CD],
                biZ_GUBUN_CD: [this.biZ_GUBUN_CD],
                biZ_STR_NM: [this.biZ_STR_NM, [Validators.required]],

                teL_NO: [this.teL_NO, [Validators.required, this.telValidator]],
                hP_NO: [this.hP_NO, [this.telValidator]],
                faX_NO: [this.faX_NO],
                posT_NO: [this.posT_NO],

                emaiL_ADDR: [this.emaiL_ADDR, [Validators.email]],
                homepage: [this.homepage, [Validators.pattern(/^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/)]],
                addr: [{ value: this.addr, disabled: true }],
                addR_DTL: [this.addR_DTL, [Validators.required]],

                stR_STAT: [this.stR_STAT],
                stR_OPEN_DT: [this.stR_OPEN_DT],
                stR_CLOSE_DT: [this.stR_CLOSE_DT],

                vaN_CD: [{ value: this.vaN_CD, disabled: true }],
                vaN_CD_NM: [{ value: this.vaN_CD_NM, disabled: true }],
                tid: [{ value: this.tid, disabled: true }],
                storE_AUTH_CD: [this.storE_AUTH_CD],

                comport: [{ value: this.comport, disabled: true }],
                bauD_RATE: [{ value: this.bauD_RATE, disabled: true }],
                agetnT_TP: [this.agetnT_TP],

                reservE_YN: [this.reservE_YN],
                reserveChecked: [this.reserveChecked],
                reservE_AMT: [this.reservE_AMT],
                reservE_START_TIME: [this.reservE_START_TIME],
                reservE_END_TIME: [this.reservE_END_TIME],
                reservE_TIME_FG: [{ value: this.reservE_TIME_FG, disabled: true }],

                membeR_FG: [this.membeR_FG],
                savE_CHARGE_FG: [this.savE_CHARGE_FG],
                miN_POINT: [this.miN_POINT],
                poinsT_PERIOD: [this.poinsT_PERIOD],

                remark: [this.remark],
                usE_YN: [this.usE_YN],
                carD_DEV_TP: [{ value: this.carD_DEV_TP, disabled: true }],
            },
            {
                validators: [this.addrRequiredValidator()]
            });
    }

    editableControls = [
        'ceO_NM',
        'biZ_STR_NM',
        'teL_NO',
        'hP_NO',
        'faX_NO',
        'emaiL_ADDR',
        'homepage',
        'addR_DTL',

        'stR_STAT',
        'stR_OPEN_DT',
        'stR_CLOSE_DT',
        'comport',
        'bauD_RATE',
        'biZ_TYPE_CD',

        'reservE_YN',
        'reserveChecked',
        'reservE_AMT',
        'reservE_START_TIME',
        'reservE_END_TIME',
        'reservE_TIME_FG',

        'membeR_FG',
        'savE_CHARGE_FG',
        'miN_POINT',
        'poinsT_PERIOD',

        'remark',
        'usE_YN',
        'carD_DEV_TP'
    ];

    telValidator(control: AbstractControl) {
        if (!control.value) return null;

        const raw = control.value.replace(/\D/g, '');

        const phone = raw.substring(0, 11);

        if (!/^0\d{9,10}$/.test(phone)) {
            return { invalidTel: true };
        }

        return null;
    }

    addrRequiredValidator(): ValidatorFn {
        return (group: AbstractControl): ValidationErrors | null => {
            const addr = group.getRawValue().addr;
            return addr ? null : { addrRequired: true };
        };
    }

    formatDate(dateString: string): string {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0')

        return `${year}${month}${day}`;

    }

    private formatPhone(num: string): string {
        const digits = num.replace(/\D/g, '');

        if (digits.length === 10) {
            return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
        }

        if (digits.length === 11) {
            return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
        }

        return num;
    }

    private formatTime(num: string): Date | null {
        if (!num) return null;

        const time = num.padStart(4, '0');

        const hour = Number(time.substring(0, 2));
        const minute = Number(time.substring(2, 4));

        const now = new Date();
        now.setHours(hour, minute, 0, 0);

        return now;
    }

    private formatBizNo(num: string): string {
        const digits = num.replace(/\D/g, '');

        if (digits.length === 10) {
            return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
        }

        return num;
    }

    parseYYYYMMDD(value: string | number): Date | null {
        if (!value) return null;

        const str = value.toString();
        if (str.length !== 8) return null;

        const year = Number(str.substring(0, 4));
        const month = Number(str.substring(4, 6)) - 1;
        const day = Number(str.substring(6, 8));

        return new Date(year, month, day);
    }
}
